import { createSlice } from '@reduxjs/toolkit';

import type { HintsState } from '../types';

const initialState: HintsState = {
  iosRecordingTipDismissed: false,
};

/**
 * Encounters Hints Slice
 *
 * Persisted, per-user dismissal state for one-time tips shown in
 * the recording UI. Stored via redux-persist through the encounters
 * feature module (scoped per user, cross-tab synced).
 */
export const hintsSlice = createSlice({
  name: 'encounters/hints',
  initialState,
  reducers: {
    dismissIosRecordingTip: state => {
      state.iosRecordingTipDismissed = true;
    },
  },
});

export const { dismissIosRecordingTip } = hintsSlice.actions;
export default hintsSlice.reducer;
